import {BackgroundTask, BackgroundTaskId} from "../Types";
import jsonApi from "./jsonApi";

export async function get(backgroundTaskId: BackgroundTaskId) {
  return await jsonApi.get<BackgroundTask>(`/background_tasks/${backgroundTaskId}`);
}
